import React from "react";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { Navigate, useParams } from "react-router";
import { Page } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { INSIGHTS_SEARCH_ROUTE, STORE_INSIGHTS_SEARCH_ID } from "Constants";
import {
  useGetMySearchesQuery,
  useGetQuickSearchesQuery,
} from "../../services/insights.api";
import { resolveInsightsIndexSearch } from "../../utils";

const InsightsIndexRedirect = (): React.JSX.Element => {
  const { groupId } = useParams();
  const quickSearchesResult = useGetQuickSearchesQuery(
    groupId ? { groupId } : skipToken,
  );
  const mySearchesResult = useGetMySearchesQuery(
    groupId ? { groupId } : skipToken,
  );

  const quickSearches = quickSearchesResult.data;
  const mySearches = mySearchesResult.data;

  if (!quickSearches || !mySearches) {
    return (
      <Page.Root>
        <Page.Body
          status={getQueryStatus({
            isLoading:
              quickSearchesResult.isLoading || mySearchesResult.isLoading,
            isFetching:
              quickSearchesResult.isFetching || mySearchesResult.isFetching,
            isError: quickSearchesResult.isError || mySearchesResult.isError,
            error: quickSearchesResult.error ?? mySearchesResult.error,
            data: undefined,
          })}
        />
      </Page.Root>
    );
  }

  const storedSearchId = localStorage.getItem(STORE_INSIGHTS_SEARCH_ID);
  let target = resolveInsightsIndexSearch(
    storedSearchId,
    quickSearches,
    mySearches,
    groupId,
  );

  if (target.type === "stale") {
    localStorage.removeItem(STORE_INSIGHTS_SEARCH_ID);
    target = resolveInsightsIndexSearch(
      null,
      quickSearches,
      mySearches,
      groupId,
    );
  }

  return (
    <Navigate
      to={target.type === "target" ? target.to : INSIGHTS_SEARCH_ROUTE}
      replace
    />
  );
};

export default InsightsIndexRedirect;
